
<template>
<div class="table-wrapper">
  <table class="table-content">
    <thead class="table-header">
      <tr>
        <th>Năm {{ optionTableData["01"].year || "" }}</th>
        <th>Tháng 1</th>
        <th>Tháng 2</th>
        <th>Tháng 3</th>
        <th>Tháng 4</th>
        <th>Tháng 5</th>
        <th>Tháng 6</th>
        <th>Tháng 7</th>
        <th>Tháng 8</th>
        <th>Tháng 9</th>
        <th>Tháng 10</th>
        <th>Tháng 11</th>
        <th>Tháng 12</th>
      </tr>
    </thead>

    <tbody class="table-body">
      <tr v-if="showMonth">
        <td>Nhân sự đầu kỳ</td>
        <td v-for="i in 12" :key="i">
          {{ getMonthData("begin", i) }}
        </td>
      </tr>
      <tr v-if="showMonth">
        <td>Nhân sự mới trong kỳ (tháng)</td>
        <td v-for="i in 12" :key="i">
          {{ getMonthData("new", i) }}
        </td>
      </tr>
      <tr v-if="showMonth">
        <td>Nhân sự nghỉ trong kỳ (tháng)</td>
        <td v-for="i in 12" :key="i">
          {{ getMonthData("leave", i) }}
        </td>
      </tr>
      <tr v-if="showMonth">
        <td>Nhân sự cuối kỳ (tháng)</td>
        <td v-for="i in 12" :key="i">
          {{ getMonthData("end", i) }}
        </td>
      </tr>
      <tr v-if="showMonth">
        <td>Nhân sự bình quân (tháng)</td>
        <td v-for="i in 12" :key="i">
          {{
            getMonthData("avgMonthEmployee", i)
          }}
        </td>
      </tr>
      <tr v-if="showMonth">
        <td>Tỷ lệ nghỉ (tháng)</td>
        <td v-for="i in 12" :key="i">
          {{
            getMonthData("leaveRatio", i)
          }}
        </td>
      </tr>
      <tr v-if="showQuarter">
        <td>Nhân sự mới trong kỳ (quý)</td>
       <td v-for="i in 4" :key="i" colspan="3">
          {{
            getQuarterData("newQuarter", i)
          }}
        </td>
      </tr>
      <tr v-if="showQuarter">
        <td>Nhân sự nghỉ trong kỳ (quý)</td>
       <td v-for="i in 4" :key="i" colspan="3">
          {{
            getQuarterData("leaveQuarter", i)
          }}
        </td>
      </tr>
      <tr v-if="showQuarter">
        <td>Nhân sự bình quân (quý)</td>
        <td v-for="i in 4" :key="i" colspan="3">
          {{
            getQuarterData("avgEmployeeQuarter", i)
          }}
        </td>
      </tr>
      <tr v-if="showQuarter">
        <td >Tỷ lệ nghỉ (quý)</td>
        <td v-for="i in 4" :key="i" colspan="3">
          {{
            getQuarterData("leaveRatioQuarter", i)
          }}
        </td>
      </tr>
      <tr v-if="showYear">
        <td >Nhân sự mới trong kỳ (năm)</td>
        <td colspan="12">{{getYearData("newYear")}}</td>
      </tr>
      <tr v-if="showYear">
        <td>Nhân sự nghỉ trong kỳ (năm)</td>
        <td colspan="12">{{getYearData("leaveYear")}}</td>
      </tr>
      <tr v-if="showYear">
        <td>Nhân sự bình quân (năm)</td>
        <td colspan="12">{{getYearData("avgEmployeeYear")}}</td>
      </tr>
      <tr v-if="showYear">
        <td>Tỷ lệ nghỉ (năm)</td>
        <td colspan="12">{{getYearData("leaveRatioYear")}}</td>
      </tr>
    </tbody>
  </table>
</div>
</template>
<script>

export default {
  name: "EmployeeTable",
  metaInfo() {
    return {
      title: "Dashboard",
      titleTemplate: "%s | " + this.$t("page_title.head_title"),
    };
  },
  components: {},

  props: ["tableData", "showMonth", "showYear", "showQuarter"],
  data() {
    return {
      optionTableData: {}
    };
  },
  async created() {
    this.getTableOptionData();
  },
  watch: {
    tableData: function() {
      this.getTableOptionData();
    }
  },

  methods: {
    getTableOptionData() {
      var tableData = Object.assign({}, this.tableData);
      const length = Object.keys(tableData).length;
      const modMonth = length % 3;
      const quarterNumber = modMonth != 0 ? Math.floor(length / 3)+ 1 : Math.floor(length / 3);
      //get month data
      for (let i =1; i<= Object.keys(tableData).length ;i++ ) {
        const index = i >= 10 ? `${i}` : `0${i}`;
        tableData[index]['avgMonthEmployee'] = ((tableData[index]['begin']|| 0) + (tableData[index]['end']|| 0)) /2 ;
        tableData[index]['leaveRatio'] = tableData[index]['avgMonthEmployee'] ? (this.formatNumber((tableData[index]['leave']|| 0) / (tableData[index]['avgMonthEmployee']|| 0) * 100)) : 0;
      }

      //get quarter and year data
      var yearData= {
        'newYear': 0,
        'leaveYear': 0,
        'avgEmployeeYear': 0,
        'leaveRatioYear': 0
      };
      var avgEmployeeYear = 0;
      for (let i=1; i<= quarterNumber; i++) {
        var quarterData= {};
        const indexMonth = i* 3 >= 10 ? `${i* 3}` : `0${i* 3}`; //last month of quarter
        const indexFirstMonth = (i-1)* 3 + 1 >= 10 ? `${(i-1)* 3 + 1}` : `0${(i-1)* 3 + 1}`; //first month of quarter
        const indexSecondMonth = (i-1)* 3 + 2 >= 10 ? `${(i-1)* 3 + 2}` : `0${(i-1)* 3 + 2}`; //second month of quarter
        if(i === quarterNumber ) {
          switch(modMonth) {
            case 1: 
              quarterData['newQuarter'] = tableData[indexFirstMonth]['new'];
              quarterData['leaveQuarter'] = tableData[indexFirstMonth]['leave'];
              quarterData['avgEmployeeQuarter'] = this.formatNumber(((tableData[indexFirstMonth]['begin'] || 0) + (tableData[indexFirstMonth]['end'] || 0)) /2);
              break;
            case 2:
              quarterData['newQuarter'] = tableData[indexFirstMonth]['new'] + tableData[indexSecondMonth]['new'];
              quarterData['leaveQuarter'] = tableData[indexFirstMonth]['leave'] + tableData[indexSecondMonth]['leave'];
              quarterData['avgEmployeeQuarter'] = ((tableData[indexFirstMonth]['begin'] || 0) + (tableData[indexSecondMonth]['end'] || 0)) /2;
              break;
            default:
              quarterData['newQuarter'] = tableData[indexMonth]['new'] + tableData[indexFirstMonth]['new'] + tableData[indexSecondMonth]['new'];
              quarterData['leaveQuarter'] = tableData[indexMonth]['leave']  + tableData[indexFirstMonth]['leave'] + tableData[indexSecondMonth]['leave'];
              quarterData['avgEmployeeQuarter'] = this.formatNumber(((tableData[indexFirstMonth]['begin'] || 0) + (tableData[indexMonth]['end'] || 0)) /2);
          } 
        }else {
          quarterData['newQuarter'] = tableData[indexMonth]['new'] + tableData[indexFirstMonth]['new'] + tableData[indexSecondMonth]['new'];
          quarterData['leaveQuarter'] = tableData[indexMonth]['leave']  + tableData[indexFirstMonth]['leave'] + tableData[indexSecondMonth]['leave'];
          quarterData['avgEmployeeQuarter'] = ((tableData[indexFirstMonth]['begin'] || 0) + (tableData[indexMonth]['end'] || 0)) /2;
        }
        quarterData['leaveRatioQuarter'] = quarterData['avgEmployeeQuarter'] ?
          this.formatNumber( quarterData['leaveQuarter'] /  quarterData['avgEmployeeQuarter']  * 100) : 0;
        avgEmployeeYear += quarterData['avgEmployeeQuarter'];
        yearData['newYear'] += quarterData['newQuarter'];
        yearData['leaveYear'] += quarterData['leaveQuarter'];
        tableData['q' + i] = quarterData;
      }
       yearData['avgEmployeeYear'] = this.formatNumber(avgEmployeeYear / quarterNumber);
       yearData['leaveRatioYear'] =  avgEmployeeYear ? (this.formatNumber(yearData['leaveYear'] / yearData['avgEmployeeYear'] * 100)) : 0;
       tableData['year'] = yearData;

       this.optionTableData = tableData;
    },
    getMonthData(name, month) {
      const data = this.optionTableData;
      let result = '-';
      if (data[month >= 10 ? `${month}` : `0${month}`] &&
        data[month >= 10 ? `${month}` : `0${month}`]?.[`${name}`] >= 0) {
        result = data[month >= 10 ? `${month}` : `0${month}`]?.[`${name}`];
        if (name === 'leaveRatio') {
          result += '%';
        }
      }
      return result;
    },
    getQuarterData(name, quarter) {
      const data = this.optionTableData;
      let result = '-';
      if (data[`q${quarter}`] && data[`q${quarter}`]?.[`${name}`] >=0) {
        result = data[`q${quarter}`]?.[`${name}`];
        if (name === 'leaveRatioQuarter') {
          result += '%';
        }
      }
      return result;
    },
    getYearData(name) {
      const data = this.optionTableData;
      let result = '-';
      if (data['year'] && data['year']?.[`${name}`] >= 0) {
        result = data['year']?.[`${name}`];
        if (name === 'leaveRatioYear') {
          result += '%';
        }
      }
      return result;
    },
    formatNumber(number) {
      return Math.round(number * 100) / 100;
    }

  },
};
</script>

<style lang="scss" scoped>
.table-wrapper {
  width: 100%;
  overflow-x: auto;
  border: 1px solid #efefef;
   &:last-child {
    margin-bottom: 10px;
  }
  &:first-child {
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
  }
   &:last-child {
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
  }
}
.table-content {
  min-width: 1120px;
  width: 100%;
  .table-header {
    tr {
      th {
        padding: 15px 0px;
        background-color: #3488eb;
        border-right: 1px solid #fff;
        color: #fff;
      }
      th:first-child {
        padding-left: 30px;
        min-width: 280px;
        // width: 28%;
        background: #3488eb;
      }

      th:not(:first-child) {
        min-width: 70px;
        width: 6%;
        text-align: center;
      }
    }
  }
  .table-body {
    tr {
      border-top: 1px solid #efefef;
      // border-left: 1px solid #efefef;
      // border-right: 1px solid #efefef;
      td {
        padding: 15px 0px;
        border-right: 1px solid #efefef;
      }
      td:last-child {
        border-right: unset;
      }
      td:first-child {
        padding-left: 30px;
        color: black;
        font-size: 14px;
        font-weight: 700;
      }
      td:not(:first-child) {
        text-align: center;
      }
    }
  }
}
</style>
